import React, { useState } from "react";
import {
  Title,
  Select,
  GoBack,
  TextArea,
  MyMessage,
  PhoneInput,
  InputField,
  DashboardIntro,
  MyActionButton,
  MyButton,
} from "../../home/component/Component";
import { codeOk } from "../../../middlewares/index";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { getOneCityGuide } from "../../../middlewares/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../middlewares/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../middlewares/libraries/imageKit/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../home/component/Pricing";
import GenerateDescription from "../utils/GenerateDescription";

const slugify = (s) =>
  s
    ? s
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "")
    : null;

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const cityguide = getOneCityGuide();

  const city_guide_id = cityguide?.city_guide_id;
  const [thumbnail, setThumbnail] = useState(cityguide?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState(cityguide?.image_cdn_id);
  const [title, setTitle] = useState(cityguide?.title || "");
  const [venue, setVenue] = useState(cityguide?.venue || "");
  const [venueCapacity, setVenueCapacity] = useState(
    cityguide?.venue_capacity ?? ""
  );
  const [startDate, setStartDate] = useState(cityguide?.start_date || "");
  const [endDate, setEndDate] = useState(cityguide?.end_date || "");
  const [startTime, setStartTime] = useState(cityguide?.start_time || "");
  const [endTime, setEndTime] = useState(cityguide?.end_time || "");

  const [email, setEmail] = useState(cityguide?.email_address || "");
  const [payLink, setPayLink] = useState(cityguide?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState(cityguide?.phone_number || "");

  const [whatsapp, setWhatsapp] = useState(cityguide?.whatsapp || "");
  const [facebook, setFacebook] = useState(cityguide?.facebook || "");
  const [twitter, setTwitter] = useState(cityguide?.twitter || "");
  const [instagram, setInstagram] = useState(cityguide?.instagram || "");
  const [youtube, setYoutube] = useState(cityguide?.youtube || "");

  const [hashtags, setHashtags] = useState(cityguide?.hashtag || "");
  const [googleMapCode, setGoogleMapCode] = useState(
    cityguide?.google_map_code || ""
  );
  const [latitude, setLatitude] = useState(cityguide?.latitude || "");
  const [longitude, setLongitude] = useState(cityguide?.longitude || "");
  const [formattedAddress, setFormattedAddress] = useState(
    cityguide?.formatted_address || ""
  );

  const [featured, setFeatured] = useState(cityguide?.featured || "no");
  const [promoted, setPromoted] = useState(
    cityguide?.promoted ? cityguide?.promoted : "no"
  );
  const [cityguideStatus, setCityGuideStatus] = useState(
    cityguide?.status ?? 1
  );
  const [expo, setExpo] = useState(cityguide?.expo ?? 0);

  const [description, setDescription] = useState(cityguide?.description || "");
  const [pricing, setPricing] = useState(cityguide?.Pricings || []);

  const [showDescriptionModal, setShowDescriptionModal] = useState(false);

  /* ---------- UI state ---------- */
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const cityGuideRoutes = "/data/city/guide";

  /* ---------- Helpers ---------- */
  const resetNotices = () => {
    setError(false);
    setSuccess(false);
    setErrorMessage("");
  };
  const onField = (setter) => (e) => {
    setter(e.target.value);
    if (error || success) resetNotices();
  };

  const respond = (isError, msg) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(msg || "");
  };

  /* ---------- Submit ---------- */
  const updateOneCityGuideHandler = async (e) => {
    e.preventDefault();
    resetNotices();
    setLoading(true);

    if (!thumbnail || !thumbnailId) return respond(true, "Image required.");
    if (!title?.trim()) return respond(true, "Title is required.");
    if (!venue?.trim()) return respond(true, "Venue is required.");
    if (!startDate || !endDate || !startTime || !endTime)
      return respond(true, "Start/End date and time are required.");

    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : cityguide?.country_id,
      first_level_id: first_level_id || 0,
      second_level_id: second_level_id || 0,
      third_level_id: third_level_id || 0,
      fourth_level_id: fourth_level_id || 0,

      title: title?.trim(),
      slug: slugify(title),

      description: description || "",
      venue: venue || "",
      venue_capacity: venueCapacity ? Number(venueCapacity) : 0,

      start_date: startDate,
      end_date: endDate,
      start_time: startTime,
      end_time: endTime,

      thumbnail: thumbnail || defaultImage,
      image_cdn_id: thumbnailId || "",

      phone_number: phoneNumber || "",
      email_address: email || "",
      pay_link: payLink,

      whatsapp: whatsapp || "none",
      facebook: facebook || "none",
      twitter: twitter || "none",
      instagram: instagram || "none",
      youtube: youtube || "none",

      hashtag: hashtags || "none",
      audio_adv: "none",

      google_map_code: googleMapCode || "none",
      latitude: latitude || "none",
      longitude: longitude || "none",
      formatted_address: formattedAddress || "",

      country_short: "none",
      status: cityguideStatus,
      featured,
      promoted,
      expo,
      pricing,
    };

    const { message, status } = await updateOneContent({
      data_id: city_guide_id,
      data,
      content: _TYPES_.CITYGUIDE,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) respond(false, message);
    else respond(true, message);
  };

  /* ---------- Layout tokens ---------- */
  const container = "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8";
  const card = "rounded-2xl border border-slate-200 bg-white shadow-sm";
  const sectionPad = "p-4 sm:p-6";
  const grid3 = "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4";
  const grid4 = "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4";

  return (
    <div className="h-full overflow-y-auto bg-slate-50">
      <div className={`${container} py-4 lg:py-6`}>
        <BreadCrumbComponent />
        <GoBack props={{ route: cityGuideRoutes }} />

        {showDescriptionModal && (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        )}

        <div className="my-4">
          <DashboardIntro
            props={{ intro: "Edit City Guide", name: entry_label }}
          />
        </div>

        <form onSubmit={updateOneCityGuideHandler}>
          <div className={`${card} ${sectionPad} space-y-6`}>
            <MyMessage
              error={error}
              message={message}
              success={success}
              onExpired={() => {
                setError(false);
                setSuccess(false);
              }}
              onClick={resetNotices}
            />

            {/* Media */}
            <ImageKitUpload
              thumbnail={thumbnail}
              thumbnailId={thumbnailId}
              setThumbnail={setThumbnail}
              setThumbnailId={setThumbnailId}
              folder={image_kit_folder(country_name, FOLDERS.CITY_GUIDE)}
            />

            {/* Details */}
            <div>
              <Title props={{ title: "City Guide Details" }} />
              <div className={grid3}>
                <InputField
                  props={{
                    id: "title",
                    title: "Title",
                    type: "text",
                    value: title,
                    onChange: onField(setTitle),
                  }}
                />
                <InputField
                  props={{
                    id: "venue",
                    title: "Venue",
                    type: "text",
                    value: venue,
                    onChange: onField(setVenue),
                  }}
                />
                <InputField
                  props={{
                    id: "venue_capacity",
                    title: "Venue Capacity",
                    type: "number",
                    value: venueCapacity,
                    onChange: onField(setVenueCapacity),
                  }}
                />
                <InputField
                  props={{
                    id: "formatted_address",
                    title: "Formatted Address",
                    type: "address",
                    value: formattedAddress,
                    onChange: onField(setFormattedAddress),
                  }}
                />
              </div>
            </div>

            {/* Date & Time */}
            <div>
              <Title props={{ title: "Date & Time" }} />
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <InputField
                  props={{
                    id: "start_date",
                    title: "Start Date",
                    type: "date",
                    value: startDate,
                    onChange: onField(setStartDate),
                  }}
                />
                <InputField
                  props={{
                    id: "end_date",
                    title: "End Date",
                    type: "date",
                    value: endDate,
                    onChange: onField(setEndDate),
                  }}
                />
                <InputField
                  props={{
                    id: "start_time",
                    title: "Start Time",
                    type: "time",
                    value: startTime,
                    onChange: onField(setStartTime),
                  }}
                />
                <InputField
                  props={{
                    id: "end_time",
                    title: "End Time",
                    type: "time",
                    value: endTime,
                    onChange: onField(setEndTime),
                  }}
                />
              </div>
            </div>

            {/* Pricing */}
            <div>
              <Title props={{ title: "Pricing" }} />
              <Pricing pricing={pricing} setPricing={setPricing} />
            </div>

            {/* Contact */}
            <div>
              <Title props={{ title: "Contact Info" }} />
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                <div className="flex flex-row justify-center items-center">
                  <PhoneInput
                    setPhone={setPhoneNumber}
                    phone={phoneNumber}
                    required={true}
                  />
                </div>
                <InputField
                  props={{
                    id: "email",
                    title: "Email Address",
                    type: "email",
                    value: email,
                    onChange: onField(setEmail),
                  }}
                />
                <InputField
                  props={{
                    id: "pay-link",
                    title: "Pay Link (Optional)",
                    type: "text",
                    value: payLink ? payLink : null,
                    onChange: (e) => {
                      setPayLink(e.target.value);
                      setError(null);
                      setSuccess(null);
                    },
                  }}
                />
              </div>
            </div>

            {/* Social */}
            <div>
              <Title props={{ title: "Social Contact" }} />
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                <InputField
                  props={{
                    id: "whatsapp",
                    title: "Whatsapp",
                    type: "text",
                    value: whatsapp,
                    onChange: onField(setWhatsapp),
                  }}
                />
                <InputField
                  props={{
                    id: "facebook",
                    title: "Facebook",
                    type: "text",
                    value: facebook,
                    onChange: onField(setFacebook),
                  }}
                />
                <InputField
                  props={{
                    id: "twitter",
                    title: "Twitter",
                    type: "text",
                    value: twitter,
                    onChange: onField(setTwitter),
                  }}
                />
                <InputField
                  props={{
                    id: "instagram",
                    title: "Instagram",
                    type: "text",
                    value: instagram,
                    onChange: onField(setInstagram),
                  }}
                />
                <InputField
                  props={{
                    id: "youtube",
                    title: "YouTube",
                    type: "text",
                    value: youtube,
                    onChange: onField(setYoutube),
                  }}
                />
              </div>
            </div>

            {/* Geo */}
            <div>
              <Title props={{ title: "Geo Position" }} />
              <div className={grid4}>
                <InputField
                  props={{
                    id: "google_map_code",
                    title: "Google Map Code",
                    type: "text",
                    value: googleMapCode,
                    onChange: onField(setGoogleMapCode),
                  }}
                />
                <InputField
                  props={{
                    id: "latitude",
                    title: "Latitude",
                    type: "text",
                    value: latitude,
                    onChange: onField(setLatitude),
                  }}
                />
                <InputField
                  props={{
                    id: "longitude",
                    title: "Longitude",
                    type: "text",
                    value: longitude,
                    onChange: onField(setLongitude),
                  }}
                />
              </div>
            </div>

            {/* Settings */}
            <div>
              <Title props={{ title: "More Settings" }} />
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                <Select
                  props={{
                    id: "cityguide_status",
                    title: "Status",
                    option: ["visible", "invisible"],
                    preselect:
                      cityguideStatus !== null
                        ? [
                            {
                              name:
                                cityguideStatus === 1 ? "visible" : "invisible",
                            },
                          ]
                        : null,
                    onChange: (e) => {
                      setCityGuideStatus(e.target.selectedIndex === 0 ? 1 : 0);
                      if (error || success) resetNotices();
                    },
                  }}
                />
                <Select
                  props={{
                    id: "featured",
                    title: "Featured",
                    option: ["no", "yes"],
                    preselect: featured ? [{ name: featured }] : null,
                    onChange: (e) => {
                      setFeatured(e.target.value);
                      if (error || success) resetNotices();
                    },
                  }}
                />
                <Select
                  props={{
                    id: "promoted",
                    title: "Promoted",
                    option: ["no", "yes"],
                    preselect: promoted ? [{ name: promoted }] : null,
                    onChange: (e) => {
                      setPromoted(e.target.value);
                      if (error || success) resetNotices();
                    },
                  }}
                />
                <Select
                  props={{
                    id: "gallery",
                    title: "Show in Gallery",
                    option: ["no", "yes"],
                    preselect:
                      expo !== null
                        ? [{ name: expo === 0 ? "no" : "yes" }]
                        : null,
                    onChange: (e) => {
                      const choice = e.target.value;
                      setExpo(choice === "yes" ? 1 : 0);
                      if (error || success) resetNotices();
                    },
                  }}
                />
              </div>
            </div>

            {/* Description */}
            <div>
              <div className="flex items-center justify-between">
                <Title props={{ title: "Description" }} />
                <MyButton
                  onClick={() => setShowDescriptionModal(true)}
                  className="bg-blue-700 hover:bg-blue-600 py-2 px-3 rounded-lg text-white"
                >
                  Generate Description
                </MyButton>
              </div>
              <TextArea
                props={{
                  id: "description",
                  title: "Description",
                  type: "text",
                  value: description,
                  onChange: onField(setDescription),
                }}
              />
            </div>

            {/* Tags */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <InputField
                props={{
                  id: "hashtag",
                  title: "Tags (comma separated)",
                  type: "text",
                  value: hashtags,
                  onChange: onField(setHashtags),
                }}
              />
            </div>

            {/* Footer actions */}
            <div className="flex justify-end">
              <MyActionButton
                loading={loading}
                title="Save Changes"
                onClick={resetNotices}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Edit;
